import { RouteInfo } from "app/shared/vertical-menu/vertical-menu.metadata";

//Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
  {
    path: "#",
    title: "System",
    icon: "ft-monitor",
    submenu: [
      {
        path: "/users",
        title: "Users",
        permission: 'users.*',
      } as RouteInfo,
      {
        path: "/roles",
        title: "Roles",
        permission: 'roles.*',
      } as RouteInfo,
      {
        path: "/companies",
        title: "Companies",
        permission: 'companies.*',
      } as RouteInfo,
      {
        path: "/company-groups",
        title: "Company groups",
        permission: 'company-groups.*',
      } as RouteInfo,
      {
        path: "/logs",
        title: "Log",
        permission: 'logs.*',
      } as RouteInfo,
      {
        path: "",
        title: "Subscriptions",
        submenu: [
          {
            path: "/subscriptions",
            title: "Subscriptions",
            permission: 'subscriptions.*',
          } as RouteInfo,
          {
            path: "/subscription-types",
            title: "Subscription types",
            permission: 'subscriptions.*',
          } as RouteInfo,
        ],
      } as RouteInfo,
      {
        path: "/settings",
        title: "Settings",
        permission: 'settings.*',
      } as RouteInfo,

            {
        path: "",
        title: "PDF documents",
        icon: "",
        class: "has-sub",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [
          {
            path: "/pdf/document-types",
            title: "Document types",
            icon: "",
            permission: "pdf-document-types.*",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
          },
          {
            path: "/pdf/headers-footers",
            title: "Headers / Footers",
            icon: "",
            permission: "pdf-headers-footers.*",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
          },
          {
            path: "/pdf/layouts",
            title: "Layouts",
            icon: "",
            permission: "pdf-layouts.*",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
          },
          {
            path: "/pdf/documents",
            title: "Documents",
            icon: "",
            permission: "pdf-documents.*",
            class: "",
            badge: "",
            badgeClass: "",
            isExternalLink: false,
            submenu: [],
          },
        ],
      },
    ],
  } as RouteInfo,
];
